import React from 'react'
import PropTypes from 'prop-types'
import './style.css'
import NRTCardStack from "../../../../../../../../components/_common/CardStack"
import NRTListItem from "../../../../../../../../components/_common/ListItem"
import NRTForumMessages from "../../../../../../../../components/_ead/ForumMessages"
import NRTBreadcrumb from "../../../../../../../../components/_common/Breadcrumb"
import EadRequests from "../../../../../../../../requests/ead-requests"
import MCEadInputLabel from "../../../../../../../../components/_ead/InputLabel"
import moment from "moment/moment"
import MCLoadingOverlay from "../../../../../../../../components/_minha-central/LoadingOverlay"
import NRTFormInput from "../../../../../../../../components/_common/_form/FormInput";
import NRTButton from "../../../../../../../../components/_common/_buttons/Button"
import NRTFormStateManager from "../../../../../../../../components/_common/_form/FormStateManager";
import NRTHorizontalStack from "../../../../../../../../components/_common/_containers/HorizontalStack"

const SIMULATE_GET_FORUMS_ERROR = false
const SIMULATE_GET_TOPIC_MESSAGES_ERROR = false
const SIMULATE_SEND_MSG_ERROR = false


class EadForumPage extends React.Component {

    state = {
        awaiting: true,
        activeCard: 0,
        selectedForum: null,
        selectedTopic: null,
        forums: [],
        messages: [],
        loadingChat: false
    }


    static getDerivedStateFromProps(nextProps, prevState) {

        const {match} = nextProps
        const {params} = match
        const forumId = params.tabParam1
        const topicId = params.tabParam2

        if (!topicId && !forumId) {
            return {
                activeCard: 0,
                selectedForum: null,
                selectedTopic: null
            }

        }

        const {forums} = prevState || []
        const forum = forums.filter((forum) => forum.code + '' === forumId + '')[0]

        if (!forum)
            return null

        const topic = topicId ?
            forum.forumTopicDTOs.filter((topic) => topic.code + '' === topicId + '')[0] : null

        return {
            activeCard: (!!topic ? 2 : 1),
            selectedForum: forum,
            selectedTopic: topic
        }
    }

    componentDidUpdate(prevProps, prevState, ss) {
        if(prevState.selectedTopic !== this.state.selectedTopic && !!this.state.selectedTopic){
          this.goToMessages(this.state.selectedTopic)
        }
    }


    componentDidMount() {

        const req = SIMULATE_GET_FORUMS_ERROR ?
            Promise.reject('SIMULATE_GET_FORUMS_ERROR') :
            EadRequests.searchForums({prlCode: this.props.release.code})

        req
            .then(result => {
                if (!result.success) {

                    //erro
                    return null
                } else {
                    this.setState({forums: result.forum})
                }

                this.setState({awaiting: false})

            })
            .catch(error => {
                this.onError(error, 'Ocorreu um erro inesperado.')

            })

    }


    onStepClicked = (step, index) => {

        switch (index) {
            case 0:
                return this.goToForumsHome()
            case 1:
                return this.goToTopics(this.state.selectedForum)
        }

    }


    goToForumsHome = () => this.props.history.push(`/conta/curso/${this.props.accountId}/forum`)
    goToTopics = (forum) => this.props.history.push(`/conta/curso/${this.props.accountId}/forum/${forum.code}`)

    goToMessages = (topic) => {
        const forum = this.state.selectedForum


        const req = SIMULATE_GET_TOPIC_MESSAGES_ERROR ?
            Promise.reject('SIMULATE_GET_TOPIC_MESSAGES_ERROR') :
            EadRequests
                .searchForumPosts({
                    ftpCode: topic.code,
                    orderByClause: "s.postDate"
                })

        this.setState({awaiting: true}, () => {
            req
                .then(result => {
                    if (!result.success) {
                        return this.onError(
                            'Erro na requisicao de get das msgs do topico',
                            'Ocorreu um erro ao carregar as mensagens do tópico.'
                        )
                    }


                    this.setState(
                        {
                            messages: result.forumpost,
                            awaiting: false,
                        },
                        () => this.props.history.push(`/conta/curso/${this.props.accountId}/forum/${forum.code}/${topic.code}`)
                    )
                })
                .catch(error => {
                    return this.onError(
                        error,
                        'Ocorreu um erro ao carregar as mensagens do tópico.'
                    )
                })

        })

    }


    sendMessageToTopic = (message) => {
        this.setState({
            loadingChat: true
        })

        const {person} = this.props.context
        const topic = this.state.selectedTopic

        const req = SIMULATE_SEND_MSG_ERROR ?
            Promise.reject('SIMULATE_SEND_MSG_ERROR') :
            EadRequests.saveForumPost({
                forumTopicDTO: topic,
                personPostCode: person.code,
                personPostName: person.name,
                personTypesPost: person.types,
                postDate: moment(),
                post: message
            })


        req
            .then(result => {
                if (!result.success)
                    return this.onError('Erro ao postar mensagem', 'Ocorreu um erro ao enviar a mensagem.')


                this.setState(state => ({
                    messages: [
                        ...state.messages,
                        result
                    ],
                    loadingChat: false
                }))
            })
            .catch(error => {
                this.onError(error, 'Ocorreu um erro ao enviar a mensagem.')
            })


    }


    onError(error, message, data) {

        console.error(error)

        this.setState({awaiting: false})

        this.props.context.set({
            toastMessage: {
                type: 'error',
                content: message
            }
        })
        this.props.context.logError(error, data)
    }

    submit = async () => {

        const ftpTitle = this.state.values.topic
        const fomCode = this.state.selectedForum.code
        const prlCode = this.props.context.eadAccount.code
        const prsCodeCreation = this.props.context.person.code


        if (!ftpTitle) {
            console.log("invalido")
            return null
        }

        const forumTopicDTO = {
            prlCode: prlCode,
            prsCodeCreation: prsCodeCreation,
            ftpTitle: ftpTitle,
            fomCode: fomCode
        }

        const result = await EadRequests.saveForumTopic(forumTopicDTO)

        const success = result.success

        if (success) {
            const selectedForum = this.state.selectedForum
            const result = await EadRequests.searchForums({prlCode: this.props.release.code})

            this.setState({
                forums: result.forum,
                selectedForum: result.forum.filter(f => f.code === selectedForum.code)[0]
            })

            this.newTopicInput.setValue("")
            this.props.context.set({
                toastMessage: {
                    type: 'success',
                    content: "Tópico criado com sucesso!"
                }
            })
        } else {
            this.props.context.set({
                toastMessage: {
                    type: 'error',
                    content: "Ocorreu um erro ao criar tópico. Recarregue a página e tente novamente. Caso o erro persista, entre em contato conosco.",
                }
            })
        }
    }


    render() {


        const {
            forums,
            awaiting,
            selectedForum,
            selectedTopic,
            activeCard
        } = this.state

        const hasTopics = selectedForum && selectedForum.forumTopicDTOs

        const steps = [
            {
                code: 'initial',
                title: 'Fóruns'
            },
            selectedForum,
            selectedTopic,
        ].filter((step) => !!step)
            .map(step => ({
                code: step.code,
                display: step.title,
            }))


        return (
            <div className={'nrt-ead-forum'}>

                <MCLoadingOverlay show={awaiting}/>
                <MCEadInputLabel text={
                    <NRTBreadcrumb steps={steps}
                                   onStepClicked={this.onStepClicked}
                    />
                }/>


                {
                    forums.length === 0 &&
                    <div>
                        <h3 style={{
                            textAlign: 'center',
                            opacity: .5
                        }}
                        >Não existem fóruns no momento.
                        </h3>
                    </div>
                }
                <NRTCardStack activeCard={activeCard}>
                    <ul>
                        {
                            forums.sort((a, b) => a.code - b.code).map((forum) =>
                                <NRTListItem key={'forum' + forum.code}
                                             style={{
                                                 borderRight: 0,
                                                 borderLeft: 0
                                             }}
                                             onClick={() => this.goToTopics(forum)}>
                                    {forum.title}
                                </NRTListItem>
                            )
                        }
                    </ul>

                    <ul>
                        {
                            this.props.context.person.type === 4 &&
                            <NRTFormStateManager onStateChange={(form) => this.setState(form)}>
                                <NRTHorizontalStack fractions={[
                                    4, 1
                                ]}>
                                    <NRTFormInput
                                        name={'topic'}
                                        customProps={{onEnterPressed: this.submit}}
                                        ref={(i) => this.newTopicInput = i}
                                    />

                                    <NRTButton onClick={this.submit} content={'novo tópico'}/>

                                </NRTHorizontalStack>
                            </NRTFormStateManager>
                        }

                        {
                            hasTopics &&
                                selectedForum.forumTopicDTOs.sort((a, b) => a.code - b.code).map((topic) =>
                                <NRTListItem key={'topic' + topic.code}
                                             style={{
                                                 borderRight: 0,
                                                 borderLeft: 0
                                             }}
                                             onClick={() => this.goToMessages(topic)}>
                                    {topic.title}
                                </NRTListItem>
                            )
                        }
                        {
                            !hasTopics &&
                            <p> Não existem tópicos no momento. </p>
                        }

                    </ul>

                    <NRTForumMessages onSendMessage={this.sendMessageToTopic}
                                      loadingChat={this.state.loadingChat}
                                      messages={this.state.messages}
                                      prsCode={this.props.context.person.code}
                    />

                </NRTCardStack>

            </div>
        )
    }

}

EadForumPage.propTypes = {
    match: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    release: PropTypes.object.isRequired,
    context: PropTypes.object.isRequired,
}

EadForumPage.defaultProps = {}


export default EadForumPage



// WEBPACK FOOTER //
// ./src/_pages/Account/_pages/CourseList/_pages/Course/_partials/Forum/index.js